import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import AnalogClock from '../AnalogClock/AnalogClock.component';
import Timer from '../../Timer/Timer.container';
import Typography from '../../Typography/Typography.component';
import { convertFromUtc } from '../Clock.utils';
import useDevicePlatform, {
	DeviceType,
} from '../../../../hooks/useDevicePlatform.hook';
import colors from '../../../../config/colors';
import ImageIcon from '../../Icon/ImageIcon.component';


interface ClockDisplayProps {
	size?: number;
	isRunning: boolean;
	initialTime: any;
	shiftTime: number;
	totalReported: number;
	reachedMax: () => void;
	enterTime?: string | null;
	isFullDayReport?: boolean;
}

const ClockDisplay = ({
	size: sizeProp,
	isRunning,
	initialTime,
	shiftTime,
	totalReported,
	reachedMax,
	enterTime,
	isFullDayReport,
}: ClockDisplayProps) => {
	const platform = useDevicePlatform();
	const isMobile = platform !== DeviceType.WEB;
	const size = sizeProp || (isMobile ? 180 : 180);
     const clockTextColor = isRunning ? colors.primaryDarkBlue : colors.clockGreyText;

	const formattedEnterTime = enterTime
		? convertFromUtc(enterTime, true)
		: null;

	if (isFullDayReport) {
		return (
			<View style={[styles.container, { width: size, height: size }]}>
				<ImageIcon name='starPlaceholder' width={95} height={95} />
			</View>
		);
	}

	return (
		<View style={[styles.container, { width: size, height: size }]}>
            {/* The AnalogClock component is designed to fit within the container, so we pass the 'size' prop to it. */}
			<AnalogClock size={size} isRunning={isRunning} />
			<View style={styles.overlay}>
				{initialTime ? (
					<View style={styles.timerContent}>
						<Timer
							max={shiftTime - totalReported}
							maxAlert={reachedMax}
							initialTime={initialTime}
							textColor={clockTextColor as any}
							fontSize={24}
						/>
						<View style={styles.entryTimeRow}>
							{formattedEnterTime ? (
								<>
									<Typography
										size={12}
										color='greyText'
										weight='normal'
									>
										{formattedEnterTime}
									</Typography>
									<ImageIcon
										name='clockLogin'
										width={14}
										height={14}
										
									/>
								</>
							) : null}
						</View>
					</View>
				) : (
					<Typography
						size={28}
						color='darkGrey'
						weight='normal'
						style={styles.idleTime}
					>
						00:00:00
					</Typography>
				)}
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		alignItems: 'center',
		justifyContent: 'center',
	},
	overlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		alignItems: 'center',
		justifyContent: 'center',
	},
	timerContent: {
		alignItems: 'center',
		justifyContent: 'center',
	},
	entryTimeRow: {
		position: 'absolute',
		top: '100%',
		flexDirection: 'row',
		alignItems: 'center',
		marginTop: 4,
		gap: 4,
	},
	clockIcon: {
		marginLeft: 2,
	},
	idleTime: {
		opacity: 0.4,
	},
});

export default ClockDisplay;
